import AppHeader from "@/components/AppHeader";
import Footer from "@/components/Footer";
import { Shield, Lock, Eye, Cookie, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { PageHero } from "@/components/PageHero";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <AppHeader currentPage="privacy" />
      
      <main className="flex-1 pt-20 pb-24 px-4">
        <div className="max-w-7xl mx-auto space-y-4">
          <PageHero
            title="Privacy Policy"
            subtitle="How we collect, use, and protect your information on Flow Marketplace"
          />

          {/* Content cards */}
          <div className="space-y-6">
            <Card className="bg-gradient-to-br from-primary/10 via-card to-card border-primary/20 hover:border-primary/40 transition-all duration-300 backdrop-blur-sm">
              <CardContent className="p-6">
                <div className="flex flex-col sm:flex-row gap-4 sm:items-start">
                  <div className="p-3 rounded-xl gradient-primary flex-shrink-0">
                    <Eye className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-foreground mb-2">Data We Collect</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      Flow Marketplace collects only essential data: wallet address, NFT metadata, and transaction history. 
                      We minimize data collection to what's necessary for platform functionality.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-accent/10 via-card to-card border-accent/20 hover:border-accent/40 transition-all duration-300 backdrop-blur-sm">
              <CardContent className="p-6">
                <div className="flex flex-col sm:flex-row gap-4 sm:items-start">
                  <div className="p-3 rounded-xl gradient-primary flex-shrink-0">
                    <Lock className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-foreground mb-2">How We Use Your Data</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      No personal data is sold or shared with third parties. Data is used solely to facilitate NFT transactions, 
                      distribute EMON rewards, prevent fraud, and improve platform security.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-primary/10 via-card to-card border-primary/20 hover:border-primary/40 transition-all duration-300 backdrop-blur-sm">
              <CardContent className="p-6">
                <div className="flex flex-col sm:flex-row gap-4 sm:items-start">
                  <div className="p-3 rounded-xl gradient-primary flex-shrink-0">
                    <Shield className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-foreground mb-2">Blockchain Transparency</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      All on-chain transactions are public on Solana blockchain. Off-chain data is stored securely 
                      in our database with encryption and retained only as long as needed for platform operations.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-accent/10 via-card to-card border-accent/20 hover:border-accent/40 transition-all duration-300 backdrop-blur-sm">
              <CardContent className="p-6">
                <div className="flex flex-col sm:flex-row gap-4 sm:items-start">
                  <div className="p-3 rounded-xl gradient-primary flex-shrink-0">
                    <Cookie className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-foreground mb-2">Cookies & Sessions</h2>
                    <p className="text-muted-foreground leading-relaxed">
                      Cookies are used for session management only. We do not use tracking cookies or share 
                      browsing data with advertisers.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="bg-gradient-to-br from-primary/20 via-accent/10 to-card border-primary/30 hover:border-primary/50 transition-all duration-300 backdrop-blur-sm">
              <CardContent className="p-6">
                <div className="flex flex-col sm:flex-row gap-4 sm:items-start overflow-hidden">
                  <div className="p-3 rounded-xl gradient-primary flex-shrink-0">
                    <Mail className="h-5 w-5 text-primary-foreground" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h2 className="text-xl font-semibold text-foreground mb-2">Contact Us</h2>
                    <p className="text-muted-foreground leading-relaxed mb-3">
                      By using Flow Marketplace, you consent to this policy. For any privacy-related questions or concerns:
                    </p>
                    <a 
                      href="mailto:support@emonboost.com" 
                      className="inline-flex items-center gap-2 px-3 py-2 rounded-lg bg-primary/20 hover:bg-primary/30 text-primary font-medium transition-all duration-300 hover:scale-105 text-sm sm:text-base break-all"
                    >
                      <Mail className="h-4 w-4 flex-shrink-0" />
                      <span className="truncate sm:overflow-visible">support@emonboost.com</span>
                    </a>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
